import { gql } from '@apollo/client';

export const verificationTypeItem = gql`
  fragment verificationTypeItem on VerificationTypeItem {
    verificationTypeId
    verificationName
    reportId
    contentType
    isActive
    storedProcedureName
    triggeredBySystem
    validityTypeId
    validityDays
    fileNameFormat
    consentTypeId
    applyFormula
    entityType
    triggersVerifications
    groupId
    parentVerificationTypeId
    summaryTitle
    summary
    kindOfVerificationId
    useInRiskDecision
    requiresIdentifier
    triggeredByExternalSearch
    fieldBaseSecurity
    documentTypes {
      verificationTypeXDocumentTypeId
      verificationTypeId
      documentTypeId
      documentName
      isSelected
    }
    userGroups {
      verificationTypeId
      userGroup {
        id
        name
      }
      viewReportYN
      viewSummaryYN
    }
  }
`;

export const verificationFormula = gql`
  fragment verificationFormula on VerificationFormula {
    partnerRoleName
    partnerName
    verificationName
    applyFormula
    evaluationString
    result
  }
`;
